'use strict';

var parseHref = require('./parseHref.js');

/**
 * Parses the given URI and returns the href value.
 *
 * @param maybeHref - The URI to parse.
 * @returns The href value of the parsed URI, or `undefined` if the URI is `null` or `undefined`.
 */ function parseUri(maybeHref) {
    var _parseHref_href;
    return (_parseHref_href = parseHref(maybeHref).href) != null ? _parseHref_href : undefined;
}

module.exports = parseUri;
